import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { FileText, CheckCircle, ChevronRight, Eye, Loader2 } from 'lucide-react';
import { formatDate, formatDateTime } from '../../lib/dateUtils';

export default function MentorInformesTab({
    pendingReports, loadingReports, handleApproveReport, MODULE_NAMES
}) {
    return (
        <>
            <div className="flex items-center justify-between mb-6">
                <div><h2 className="text-lg font-semibold text-[#1F2933] font-['Outfit']">Informes pendientes de aprobación</h2><p className="text-sm text-[#616E7C]">Revisa, edita y aprueba los informes de acompañamiento</p></div>
                <Badge className="bg-[#E8B27A]/10 text-[#E8B27A] text-lg px-3 py-1">{pendingReports.length}</Badge>
            </div>

            {loadingReports ? (
                <div className="text-center py-12"><Loader2 className="h-8 w-8 animate-spin mx-auto text-[#425A65]" /></div>
            ) : pendingReports.length === 0 ? (
                <Card className="bg-white border-[#EAE8E3]"><CardContent className="py-12 text-center"><FileText className="h-12 w-12 mx-auto text-[#EAE8E3] mb-3" /><p className="text-[#616E7C]">No hay informes pendientes</p><p className="text-sm text-[#9AA5B1] mt-1">Los informes aparecerán aquí cuando los usuarios completen módulos</p></CardContent></Card>
            ) : (
                <div className="space-y-3">
                    {pendingReports.map(report => (
                        <Card key={report.id} className="bg-white border-[#EAE8E3] shadow-sm" data-testid={`report-${report.id}`}>
                            <CardContent className="py-4">
                                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                                    <div className="flex items-center gap-3 min-w-0">
                                        <div className="w-10 h-10 bg-[#E8B27A]/10 rounded-xl flex items-center justify-center shrink-0"><FileText className="h-5 w-5 text-[#E8B27A]" /></div>
                                        <div className="min-w-0">
                                            <p className="font-medium text-sm text-[#1F2933]">{report.user_name || 'Usuario'} - {MODULE_NAMES[report.module_id] || report.module_id}</p>
                                            <p className="text-xs text-[#9AA5B1]">Cap. {report.chapter} - {formatDate(report.created_at)}</p>
                                        </div>
                                    </div>
                                    <div className="flex gap-2">
                                        <Link to={`/mentor/usuario/${report.user_id}`}><Button variant="outline" size="sm" className="border-[#EAE8E3] text-[#616E7C]"><Eye className="h-3.5 w-3.5 mr-1" />Ver perfil</Button></Link>
                                        <Button size="sm" className="bg-[#5FAF9D] hover:bg-[#4A9A89] text-white" onClick={() => handleApproveReport(report.id, false)} data-testid={`approve-${report.id}`}><CheckCircle className="h-3.5 w-3.5 mr-1" />Aprobar (interno)</Button>
                                        <Button size="sm" className="bg-[#3E5F6E] hover:bg-[#2F4A57] text-white" onClick={() => handleApproveReport(report.id, true)} data-testid={`approve-send-${report.id}`}><ChevronRight className="h-3.5 w-3.5 mr-1" />Aprobar y enviar al usuario</Button>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    ))}
                </div>
            )}
        </>
    );
}
